export default "__VITE_ASSET__DgRyEVpv__"